import { secureStorage } from "@/services/secureStorage";

function mergeUsersToCompetitionData(state, rootState, commit) {
    const competitionData = rootState.competition.competitionData;

    if (!competitionData || typeof competitionData !== 'object') return;

    const competitionId = competitionData.id;
    if (!competitionId) return;

    const originalUsers = Array.isArray(competitionData.competition_users)
        ? competitionData.competition_users
        : [];

    // ⚠️ Filtramos solo los users que pertenecen a esta competición
    const relevantChanges = state.competitionUsers.filter(
        user => user.competition_id === competitionId
    );

    // Si no hay cambios relevantes, no hacemos nada
    if (relevantChanges.length === 0) return;

    // Creamos un mapa para combinar datos
    const userMap = new Map();

    // Paso 1: cargar los originales
    for (const user of originalUsers) {
        userMap.set(user.id, { ...user });
    }

    // Paso 2: aplicar los cambios relevantes
    for (const changed of relevantChanges) {
        const existing = userMap.get(changed.id);
        if (existing) {
            userMap.set(changed.id, { ...existing, ...changed });
        } else {
            userMap.set(changed.id, { ...changed }); // Nuevo usuario que no existía
        }
    }


    const mergedUsers = Array.from(userMap.values());

    const originalCoOrganizers = Array.isArray(competitionData.co_organizers)
        ? competitionData.co_organizers
        : [];
    const coOrganizerMap = new Map();

    for (const user of originalCoOrganizers) {
        coOrganizerMap.set(user.id, { ...user });
    }

    for (const changed of relevantChanges.filter(user => Number(user?.role_id ?? user?.pivot?.role_id) === 3)) {
        const existing = coOrganizerMap.get(changed.id);
        if (existing) {
            coOrganizerMap.set(changed.id, {
                ...existing,
                ...changed,
                user: {
                    ...(existing.user || {}),
                    ...(changed.user || {}),
                },
                status: changed.status || existing.status,
            });
        } else {
            coOrganizerMap.set(changed.id, { ...changed });
        }
    }

    const mergedCoOrganizers = Array.from(coOrganizerMap.values());

    const updatedCompetitionData = {
        ...competitionData,
        competition_users: mergedUsers,
        co_organizers: mergedCoOrganizers,
    };

    commit('competition/addOrUpdateCompetition', updatedCompetitionData, { root: true });
}


export default {
    namespaced: true,
    state: () => ({
        competitionUsers: JSON.parse(secureStorage.getItem('competitionUsers')) || [],
        atheletesListArray: JSON.parse(secureStorage.getItem('atheletesListArray')) || [],
        judgesListArray: JSON.parse(secureStorage.getItem('judgesListArray')) || []
    }),

    mutations: {
        setMutCompetitionUsers(state, users) {
            state.competitionUsers = users;
            secureStorage.setItem('competitionUsers', JSON.stringify(users));
        },
        setMutAtheletesListArray(state, users) {
            state.atheletesListArray = users;
            secureStorage.setItem('atheletesListArray', JSON.stringify(users));
        },
        setMutJudgesListArray(state, users) {
            state.judgesListArray = users;
            secureStorage.setItem('judgesListArray', JSON.stringify(users));
        },

       /* updateMutCompetitionUser(state, updatedUser) {
            if (Array.isArray(state.competitionUsers) && state.competitionUsers.length > 0) {
                const index = state.competitionUsers.findIndex(u => u.id === updatedUser.id);
                if (index !== -1) {
                    state.competitionUsers[index] = {
                        ...state.competitionUsers[index],
                        ...updatedUser
                    };
                } else {
                    state.competitionUsers.push(updatedUser);
                }
                secureStorage.setItem('competitionUsers', JSON.stringify(state.competitionUsers));
            } else {
                console.log(updatedUser);
                console.warn('⚠️ competitionUsers no está definido o está vacío. No se actualiza.');
            }
        },*/
        updateMutCompetitionUser(state, updatedUser) {
            if (!Array.isArray(state.competitionUsers)) {
                state.competitionUsers = [];
            }

            const index = state.competitionUsers.findIndex(u => parseInt(u.id) === parseInt(updatedUser.id));

            if (index !== -1) {
                state.competitionUsers[index] = {
                    ...state.competitionUsers[index],
                    ...updatedUser
                };
            } else {
                state.competitionUsers.push(updatedUser);
            }

            secureStorage.setItem('competitionUsers', JSON.stringify(state.competitionUsers));
        },


        resetCompetitionUsers(state) {
            state.competitionUsers = [];
            secureStorage.removeItem('competitionUsers');
        },
        resetAtheletesListArray(state) {
            state.atheletesListArray = [];
            secureStorage.removeItem('atheletesListArray');
        },
        resetJudgesListArray(state) {
            state.judgesListArray = [];
            secureStorage.removeItem('judgesListArray');
        }
    },

    actions: {
        setCompetitionUsers({ commit, state, rootState }, users) {
            commit('setMutCompetitionUsers', users);
            mergeUsersToCompetitionData(state, rootState, commit);
        },
        setAtheletesListArray({ commit }, users) {
            commit('setMutAtheletesListArray', users);
        },
        setJudgesListArray({ commit }, users) {
            commit('setMutJudgesListArray', users);
        },
        clearAtheletesListArray({ commit }) {
            commit('resetAtheletesListArray');
        },

        clearJudgesListArray({ commit }) {
            commit('resetJudgesListArray');
        },

        clearCompetitionUsers({ commit, rootState }) {
            commit('resetCompetitionUsers');
            const competitionData = rootState.competition.competitionData;
            if (competitionData) {
                commit('competition/addOrUpdateCompetition', {
                    ...competitionData,
                    competition_users: [],
                }, { root: true });
            }
        },

        updateCompetitionUser({ commit, state, rootState }, updatedUser) {
            const currentCompetitionId = rootState.competition.competitionData?.id;
            if (!currentCompetitionId) return;
            const payload = updatedUser?.data && typeof updatedUser.data === 'object'
                ? updatedUser.data
                : updatedUser;
            const competitionUser = payload?.competition_users || payload?.competition_user;
            const incomingCompetitionId = Number(payload?.competition_id ?? competitionUser?.competition_id ?? currentCompetitionId);

            if (incomingCompetitionId === Number(currentCompetitionId) && competitionUser?.id) {
                commit('updateMutCompetitionUser', {
                    ...competitionUser,
                    competition_id: competitionUser?.competition_id ?? incomingCompetitionId,
                });
                mergeUsersToCompetitionData(state, rootState, commit);
            } else {
                console.warn(`🚫 Usuario ${competitionUser?.id} no pertenece a la competición actual (${currentCompetitionId}). Se ignora.`);
            }
        }

    },

    getters: {
        getCompetitionUsers: state => state.competitionUsers,
        getCompetitionUserById: state => id =>
            state.competitionUsers.find(u => u.user_id === id)
    }
};
